export const SIGN_IN = "/sign-in";
export const SIGN_UP = "/sign-up";
export const VERIFY_EMAIL = "/verify";
export const FORGET_PASSWORD = "/forget-password";
export const UPDATE_PASSWORD = "/update-password";

export const HOME = "/";
export const ROUTE = '/home'
export const CREATE_CAMPAIGN = "/create-campaign/:id?";
export const EDIT_CAMPAIGN = "/edit-campaign/:id?";

export const SCREENS_LIST = "/screens-list";
export const SCREENS_LIST_FOR_SECONDARY_USER = "/screens-list-secondary";

export const ADD_NEW_USER = "/users/add-new";
export const NEW_DASHBOARD = "/campaignDashboard/:id?/:clicked";

export const USERS = "/users";
export const QUERIES = "/queries";
export const DMP_QUERIES = "/dmpQueries";

export const SCREENS_DETAILS = "/screens-details/:id?";

export const CAMPAIGNS_LIST = "/campaigns-list";
export const CAMPAIGNS_DETAILS = "/campaigns-details/:id?";

export const MY_CREATIVES = "/my-creatives";

export const SCREEN_CAMPAIGN_MONITORING = "/screen-campaign-monitoring";

export const PLAY_LIVE_URL = "/play-live-url"
export const MY_REQUESTS = "/my-requests";
export const MY_COUPONS = "/my-coupons";
